import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {AuthProvider} from "context/AuthContext";
import {FiltersProvider} from "context/FilterContext";
import {ScrollProvider} from "context/ScrollContext";
import {routes} from "conts/routes";
import {useEffect} from "react";
import {RouterProvider} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {IntercomProvider} from "react-use-intercom";
import {AppThemeProvider} from "ui/theme/AppThemeProvider";
import {pixelTrackEvent} from "utils/facebookPixel";
import {captureAttribution} from "analytics";
import "react-datepicker/dist/react-datepicker.css";
import "react-image-crop/dist/ReactCrop.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import {useNotificationListener} from "services/notifications/NotificationListener";
import {useRequestNotificationPermission} from "services/notifications/requestPermission";
import {useLayoutHeightVars} from "hooks/useLayoutHeightVars";

const queryClient = new QueryClient();

// test dev
// const INTERCOM_APP_ID = "jcabc7e3"
const INTERCOM_APP_ID = "o55y8emf";

function App() {
    useEffect(() => {
        pixelTrackEvent("Enter web page");
        captureAttribution();
    }, []);

    useLayoutHeightVars();
    useRequestNotificationPermission();
    useNotificationListener();

    return (
        <>
            <QueryClientProvider client={queryClient}>
                <IntercomProvider
                    appId={INTERCOM_APP_ID}
                    autoBoot
                    autoBootProps={{
                        actionColor: "#554DF1",
                        backgroundColor: "#554DF1",
                    }}
                    onShow={() => pixelTrackEvent("Clicked on Intercom")}
                >
                    <AuthProvider>
                        <FiltersProvider>
                            <ScrollProvider>
                                <AppThemeProvider>
                                    <RouterProvider router={routes}/>
                                </AppThemeProvider>
                            </ScrollProvider>
                        </FiltersProvider>
                    </AuthProvider>
                </IntercomProvider>
            </QueryClientProvider>
            <ToastContainer/>
        </>
    );
}

export default App;
